import { LAST_SLIDE_THRESHOLD } from '../constants';

/** Checks if Carousel is at the end and last slide is visible.
 * if `progress` is `NaN` Carousel has no scrolling and all slides are visible.
 * if `progress` is greater than LAST_SLIDE_TRESHOLD last slide is visible and Carousel is at the end.
 *
 * @param progress the number that shows in which part of Carousel we are (0 = start, 0.5 = in the half, 1 = at the end).
 * @returns the boolean, it's true when Carousel is at the end and last slide is visible.
 */
export const isCarouselAtTheEnd = progress => Number.isNaN(progress) || progress > LAST_SLIDE_THRESHOLD;
//# sourceMappingURL=isCarouselAtTheEnd.js.map